import axios from 'axios'
import authHeader from 'shared/authHeader'

class SearchService {

    static search(text) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_URL}/api/search/searchLA?q=${text}`, {
                    headers: authHeader()
                })
                resolve(res.data)
            } catch (e) {
                reject(e)
            }
        })
    }

    static getPath(id, type) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_URL}/api/search/getPathLA?id=${id}&type=${type}`, {
                    headers: authHeader()
                })
                resolve(res.data)
            } catch (e) {
                reject(e)
            }
        })
    }
}

export default SearchService
